import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import CategoryReducer from './reducers/CategoryReducer';
import {LoginReducer ,RegistrationReducer ,ForgotPasswordReducer ,ResetPasswordReducer ,GetProfileReducer,
        UpdateProfileReducer , ChangePasswordReducer , SettingReducer ,GetOrdersReducer,OrderDetailReducer,GetItemsReducer} from './reducers/UserReducer';
import {ContentReducer , ContentDtailsReducer} from './reducers/ContentReducer';
import {CartDataReducer , CartDeleteReducer , CartAddReducer , StripePaymentReducer , PaypalPaymentReducer, PayuPaymentReducer } from './reducers/PaymentReducer';

const reducer = combineReducers({
    category:CategoryReducer,
    content:ContentReducer,
    content_details:ContentDtailsReducer,
    loginState:LoginReducer,
    registrationState:RegistrationReducer,
    forgotPasswordState:ForgotPasswordReducer,
    resetPasswordState:ResetPasswordReducer,
    getProfileState:GetProfileReducer,
    updateProfileState:UpdateProfileReducer,
    changePasswordState:ChangePasswordReducer,
    settingState:SettingReducer,
    cartDataState:CartDataReducer,
    cartAddState:CartAddReducer,
    cartDeleteState:CartDeleteReducer,
    stripePaymentState:StripePaymentReducer , 
    paypalPaymentState:PaypalPaymentReducer, 
    payuPaymentState:PayuPaymentReducer,
    getOrdersState:GetOrdersReducer,
    orderDetailState:OrderDetailReducer,
    getItemsState:GetItemsReducer
})

let initialState = {}
const middleware = [thunk]
const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))
export default store;
